module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "choice_brand mt20 mb20"
  }, [_c('div', {
    staticClass: "add_name"
  }, [_c('div', {
    staticClass: "c_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌中文名称：")]), _vm._v(" "), _c('span', {
    staticClass: "f999"
  }, [_vm._v(_vm._s(_vm.brandDetail.brandName))]), _vm._v(" "), (_vm.snapshot.brandName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.snapshot.brandName))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "e_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌英文名称：")]), _vm._v(" "), _c('span', {
    staticClass: "f999"
  }, [_vm._v(_vm._s(_vm.brandDetail.brandEnname))]), _vm._v(" "), (_vm.snapshot.brandEnname) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.snapshot.brandEnname))]) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "-20px"
    },
    attrs: {
      "data": _vm.brandDetail.categories,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "主营品类",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.category.grandName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.parentName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.childrenName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否提供发票",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.provideInvoice == 0) ? _c('span', [_vm._v("否")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1) ? _c('span', [_vm._v("是")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发票类型",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.provideInvoice == 0) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.registeredCountry == 1 && scope.row.invoiceType == 1) ? _c('span', [_vm._v("增值税普通发票")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.taxpayerType == 1 && _vm.registeredCountry == 1 && scope.row.invoiceType == 2) ? _c('span', [_vm._v("增值税专用发票")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.taxpayerType == 2 && _vm.registeredCountry == 1 && scope.row.invoiceType == 2) ? _c('span', [_vm._v("增值税专用发票（需去税务局代开）")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.registeredCountry != 1 && scope.row.invoiceType == 3) ? _c('span', [_vm._v("形式发票")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "税率",
      "align": "center",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return scope.row.rates != null && scope.row.rates != undefined ? [(scope.row.rates.length == 0) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), _vm._l((scope.row.rates), function(rateValue) {
          return (scope.row.rates.length > 0) ? _c('span', [_vm._v("\n                                " + _vm._s(rateValue) + "%\n                                ")]) : _vm._e()
        })] : undefined
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "label": "品类经营特许资质电子版",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.franchiseQualification) ? _c('img', {
          staticClass: "pic_skan",
          attrs: {
            "src": scope.row.franchiseQualificationFile,
            "alt": ""
          },
          on: {
            "click": function($event) {
              _vm.previewPic($event)
            }
          }
        }) : _vm._e(), _vm._v(" "), (!scope.row.franchiseQualification == 1) ? _c('span', [_vm._v("不需要")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt20",
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.reback()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add_top"
  }, [_c('div', {
    staticClass: "add_tab active_tab"
  }, [_vm._v("品牌品类详情")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌合作品类：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f9a873b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/info_manage/brand_supple_agree/supple_brand_detail.vue
// module id = 510
// module chunks = 0